import Vue from 'vue'
import VueRouter from 'vue-router'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import sfrpg from '../views/systems/sfrpg.vue'
import playTab from '../views/tabs/Play.vue'
import basicsTab from '../views/tabs/Basics.vue'
import planningTab from '../views/tabs/Planning.vue'
import skillsTab from '../views/tabs/Skills.vue'
import combatTab from '../views/tabs/Combat.vue'
import equipmentTab from '../views/tabs/Equipment.vue'
import journalTab from '../views/tabs/Journal.vue'
import societyTab from '../views/tabs/Society.vue'


Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/sfrpg/play',
	},
	{
		path: '/sfrpg',
		component: sfrpg,
		children: [
			{
				name: 'play',
				path: 'play',
				component: playTab
			},
			{
				name: 'basics',
				path: 'basics',
				component: basicsTab
			},
			{
				name: 'planning',
				path: 'planning',
				component: planningTab
			},
			{
				name: 'skills',
				path: 'skills',
				component: skillsTab
			},
			{
				name: 'combat',
				path: 'combat',
				component: combatTab
			},
			{
				name: 'equipment',
				path: 'equipment',
				component: equipmentTab
			},
			{
				name: 'journal',
				path: 'journal',
				component: journalTab
			},
			{
				name: 'society',
				path: 'society',
				component: societyTab
			},
		],
	},
	
	//{
	//	path: '/about',
	//	name: 'about',
	//	// route level code-splitting
	//	// this generates a separate chunk (about.[hash].js) for this route
	//	// which is lazy-loaded when the route is visited.
	//	component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	//}
]

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes
})

NProgress.configure({showSpinner: false})

router.beforeEach((to, from, next) => {
	if( to.name ) {
		NProgress.start()	
	}
	next()
})

router.afterEach(() => { 
	NProgress.done()
})

export default router
